import type { TableColumnMeta } from '../common/ColumnSelector';

/** Column catalogue for the user table. Created/updated are on every user
 *  record but were never surfaced; they are available here. */
export const USER_COLUMN_METADATA: TableColumnMeta[] = [
  { id: 'username', label: 'Username', category: 'Identity' },
  { id: 'full_name', label: 'Full Name', category: 'Identity' },
  { id: 'email', label: 'Email', category: 'Identity' },
  { id: 'role', label: 'Role', category: 'Access' },
  { id: 'is_active', label: 'Status', category: 'Access' },
  { id: 'is_ldap', label: 'Source', category: 'Access' },
  { id: 'last_login', label: 'Last Login', category: 'Timestamps' },
  { id: 'created_at', label: 'Created', category: 'Timestamps' },
  { id: 'updated_at', label: 'Updated', category: 'Timestamps' },
  { id: 'actions', label: 'Actions', category: 'Actions', alwaysVisible: true },
];

/** The columns the page has always shown; created/updated stay off. */
export const USER_DEFAULT_COLUMNS = [
  'username',
  'full_name',
  'email',
  'role',
  'is_active',
  'is_ldap',
  'last_login',
  'actions',
];
